import type { DependencyList, ReactNode } from 'react';
import { useContext, useEffect, useRef } from 'react';
import { HeaderContext, HeaderSlotContext } from './context';

export const useHeaderSlot = () => useContext(HeaderSlotContext);
export const useHeaderActions = () => useContext(HeaderContext);
export function useHeader(render: () => ReactNode, deps: DependencyList) {
  const { setHeaderSlot } = useHeaderActions();
  const renderRef = useRef(render);
  renderRef.current = render;

  useEffect(() => {
    setHeaderSlot(renderRef.current());
    return () => setHeaderSlot(null);
  }, [setHeaderSlot, ...deps]);
}
